import React, { useState, useMemo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Media from '@/components/material-ui-kit/components/Media/Media';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import CustomInput from '@/components/common/ui/CustomInput';
import styles from 'styles/jss/original/components/shoppings/shoppingCommentPost';
import { SHOPPING_COMMENT_POST, SHOPPING_COMMENT_LOGIN } from '@/constants/app';
import classNames from 'classnames';
import { User } from '@/domains/firestore/user';

// @ts-expect-error
const useStyles = makeStyles(styles);

const MAX_TEXT_COUNT = 100;

type ComponentProps = {
  user: User | null;
  onRequestAuth: (snsType: string) => void;
  onRequestSubmit: (message: string) => void;
};

const ShoppingCommentPost: React.FC<ComponentProps> = ({
  user,
  onRequestAuth,
  onRequestSubmit
}) => {
  const classes = useStyles();
  const [messageValue, setMessageValue] = useState('');
  const [withText, setWithText] = useState(false);
  const [isLimit, setLimit] = useState(false);
  const labelText = isLimit ? '100文字以内で入力ください' : 'コメントを入力ください';
  const handleOnChange = useCallback((event) => {
    event.target.value ? setWithText(true) : setWithText(false);
    event.target.value.length > MAX_TEXT_COUNT ? setLimit(true) : setLimit(false);
    setMessageValue(event.target.value);
  }, []);
  const handleSubmit = useCallback(() => {
    onRequestSubmit(messageValue);
    setMessageValue('');
  }, [messageValue, onRequestSubmit]);
  const buttonList = useMemo(
    () => [
      {
        color: 'facebook',
        icon: 'facebook-f',
        onClick: () => onRequestAuth('facebook')
      },
      {
        color: 'twitter',
        icon: 'twitter',
        onClick: () => onRequestAuth('twitter')
      },
      {
        color: 'google',
        icon: 'google',
        onClick: () => onRequestAuth('google')
      }
    ],
    [onRequestAuth]
  );
  return (
    <div className={classes.section}>
      {user ? (
        // @ts-expect-error
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={10} md={8}>
            <h3 className={classes.title}>{SHOPPING_COMMENT_POST}</h3>
            <Media
              avatar={user.img}
              body={
                <CustomInput
                  labelText={labelText}
                  id='nice'
                  formControlProps={{
                    fullWidth: true
                  }}
                  error={isLimit ? true : false}
                  inputProps={{
                    multiline: true,
                    rows: 5,
                    onChange: handleOnChange,
                    value: messageValue
                  }}
                />
              }
              footer={
                // @ts-expect-error
                <Button
                  color='warning'
                  round
                  className={classes.footerButtons}
                  onClick={() => handleSubmit()}
                  disabled={!withText || isLimit}
                >
                  投稿する
                </Button>
              }
            />
          </GridItem>
        </GridContainer>
      ) : (
        // @ts-expect-error
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem md={12}>
            <h3 className={classes.title}>{SHOPPING_COMMENT_POST}</h3>
            <h5 className={classes.title}>{SHOPPING_COMMENT_LOGIN}</h5>
          </GridItem>
          {buttonList.map((item) => {
            return (
              // @ts-expect-error
              <Button color={item.color} key={item.icon} onClick={item.onClick} round justIcon>
                <i className={classNames('fab', `fa-${item.icon}`)} />
              </Button>
            );
          })}
        </GridContainer>
      )}
    </div>
  );
};

export default ShoppingCommentPost;
